export const attendanceTypes = [
    { value: 'Presencial', label: 'Presencial' },
    { value: 'Diario', label: 'Orgânico' },
    { value: 'Online', label: 'Online' },
    { value: 'Interno', label: 'Complementar' },
];